/* Two-option base-map switcher, styled like the other floating map chrome. */

.control {
    position: absolute;
    z-index: 500;
    display: inline-flex;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.95);
    border: 1px solid var(--map-hairline);
    box-shadow: var(--map-chip-shadow);
    overflow: hidden;
}

.option {
    padding: 5px 11px;
    border: none;
    background: none;
    font: inherit;
    color: #4b5563;
    cursor: pointer;
    transition: background-color 110ms ease, color 110ms ease;
}

.option + .option {
    border-left: 1px solid var(--map-hairline);
}

.option:hover {
    background-color: rgba(16, 185, 129, 0.08);
}

.option:focus-visible {
    outline: 2px solid var(--map-accent);
    outline-offset: -2px;
}

.optionActive,
.optionActive:hover {
    background-color: rgba(16, 185, 129, 0.14);
    color: var(--map-accent-ink);
}

.optionActive span {
    font-weight: 600;
}
